var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-nav'),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('queue')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }